import React, { useState } from "react";
import Card from "../../ui/card/Card";
import Button from "../../ui/button/button";
import { PRICING_PLANS } from "../../../lib/landingContent";
import JoinWaitlist from "./JoinWaitlist";
import "./pricing.css";
import "./pricing-starter.css";
import "./pricing-professional.css";
import "./pricing-enterprise.css";

const PricingSection: React.FC = () => {
  const [billing, setBilling] = useState<"monthly" | "annually">("monthly");

  const toggleBilling = () =>
    setBilling((prev) => (prev === "monthly" ? "annually" : "monthly"));

  return (
    <section className="pricing-section" id="pricing">
      <div className="pricing-inner">
        
        {/* Top Header Row */}
        <div className="pricing-topbar">
          <div>
            <p className="pricing-kicker">Choose Your Plan</p>
            <h2 className="pricing-title">Plans That Scale</h2>
          </div>

          <div
            className={`pricing-toggle ${billing === "annually" ? "is-annually" : ""}`}
            role="group"
            aria-label="Billing period"
          >
            <button
              type="button"
              className={`pricing-toggle-pill ${billing === "monthly" ? "is-active" : ""}`}
              aria-pressed={billing === "monthly"}
              onClick={toggleBilling}
            >
              MONTHLY
            </button>

            <button
              type="button"
              className={`pricing-toggle-pill ${billing === "annually" ? "is-active" : ""}`}
              aria-pressed={billing === "annually"}
              onClick={toggleBilling}
            >
              ANNUALLY
            </button>
          </div>
        </div>

        {/* Pricing Cards Stage */}
        <div className="pricing-stage">
          
          <div
            className="pricing-grid pricing-grid--blurred"
            aria-hidden="true"
          >
            {PRICING_PLANS.map((plan) => (
              <Card
                key={plan.id}
                className={`pricing-card pricing-card--${plan.id} ${
                  plan.isPopular ? "is-popular" : ""
                }`}
              >
                <div className="pricing-card-top">
                  <p className="pricing-name">{plan.name}</p>

                  <Button
                    variant="primary"
                    size="sm"
                    className="pricing-button"
                  >
                    Subscribe
                  </Button>
                </div>

                <ul className="pricing-features">
                  {plan.features.map((feature) => (
                    <li key={feature}>{feature}</li>
                  ))}
                </ul>

                <div className="pricing-footer-notes">
                  <p>No setup fee</p>
                  <p>No hidden fee</p>
                  <p>All features unlocked</p>
                </div>
              </Card>
            ))}
          </div>

          {/* Waitlist Foreground Box */}
          <JoinWaitlist />
          
        </div>
      </div>
    </section>
  );
};

export default PricingSection;